import {gql} from 'apollo-angular';
import {StatusFragment} from "../queries/fragments/Status";

export const SEND_TEACHING_IDEA = gql`
  mutation SendTeachingIdea($formData: InTeachingIdea!, $classId: Int!) {
    sendTeachingIdea(data: $formData, schoolClassID: $classId) {
      type
      message
    }
  }
`;
